import { Outlet, type RouteObject } from 'react-router-dom';
import { RequireAuth } from '@/auth/RequireAuth';
import type { RouteHandle } from '@/layout/routeHandle';
import { FishingGroundDetailPage } from './FishingGroundDetailPage';
import { FishingGroundFormPage } from './FishingGroundFormPage';
import { FishingGroundListPage } from './FishingGroundListPage';

/**
 * catch（担当: G4）。S-60 漁場情報一覧（CSV 取込）／S-61 登録・編集／S-62 詳細。
 * 一覧・詳細は全ロール（庁県は参照）、登録・編集は基金・漁協。
 */
export const routes: RouteObject[] = [
  {
    path: 'fishing-grounds',
    handle: { crumb: '漁獲調査' } satisfies RouteHandle,
    element: (
      <RequireAuth>
        <Outlet />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <FishingGroundListPage /> },
      {
        path: 'new',
        element: (
          <RequireAuth roles={['基金', '漁協']}>
            <FishingGroundFormPage />
          </RequireAuth>
        ),
        handle: { crumb: '新規登録' } satisfies RouteHandle,
      },
      { path: ':id', element: <FishingGroundDetailPage />, handle: { crumb: '詳細' } satisfies RouteHandle },
      {
        path: ':id/edit',
        element: (
          <RequireAuth roles={['基金', '漁協']}>
            <FishingGroundFormPage />
          </RequireAuth>
        ),
        handle: { crumb: '編集' } satisfies RouteHandle,
      },
    ],
  },
];
